<template lang="pug">
span(v-if="activeConditions.length")
  v-card
    v-layout.px-2(column)
      v-flex
        v-tooltip(bottom left :disabled="enableAddToDashboard")
          v-checkbox(
            slot="activator"
            :disabled="!enableAddToDashboard"
            :label="dashboardFilterCheckboxLabel"
            :input-value="isDisplayedOnDashboard"
            hide-details
            @change="setDisplayOnDashboard"
            color='primary'
          )
          span {{ maxDashboardFiltersMessage }}
      v-flex
        v-checkbox(
          :disabled="!enableAddToDashboard"
          :input-value="selectedFilter.show_contacts_slipping_away"
          hide-details
          @change="setDashboardContactsSlippingAway"
          color='primary'
          )
            div(slot="label")
              label {{ contactSlippingAwayCheckboxLabel }}
              v-text-field.days-text-field(
                type="number"
                :value="slippingAwayDays"
                hide-details
                @click.stop=""
                @input="setSlippingAwayDays"
              )
              label days
      v-flex
        v-switch.d-inline-flex(
          :label="showContactsSlippingAwaySwitchLabel"
          :input-value="applyContactsSlippingAwayConditions"
          @change="toggleShowContactsSlippingAway"
          color='primary'
          )
        v-tooltip(bottom)
          span New contacts created during the specified days are not considered as contact slipping away.
          v-icon.ml-2(slot="activator") info
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

const {
  mapActions: mapContactFilterActions,
  mapState: mapContactFiltersState,
} = createNamespacedHelpers('contactFilters');

export default {
  props: {
    activeConditions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      contactSlippingAwayCheckboxLabel:
        'Also show number of contacts slipping away with no events created over the last',
      maxDashboardFiltersMessage:
        'Maximum of ten dashboard filters already selected, please deselect one or more filters.',
      dashboardFilterCheckboxLabel:
        'Show total number of contacts on dashboard (ten filters maximum)',
      showContactsSlippingAwaySwitchLabel: 'Show Contacts Slipping Away',
    };
  },
  computed: {
    ...mapContactFiltersState([
      'selectedFilter',
      'slippingAwayDays',
      'applyContactsSlippingAwayConditions',
      'dashboardFiltersCount',
      'isDisplayedOnDashboard',
    ]),
    enableAddToDashboard() {
      return this.selectedFilter.display_on_dashboard || this.dashboardFiltersCount < 10;
    },
  },
  methods: {
    ...mapContactFilterActions([
      'setDashboardContactsSlippingAway',
      'setDisplayOnDashboard',
      'setSlippingAwayDays',
      'toggleShowContactsSlippingAway',
    ]),
  },
};
</script>
<style lang="scss">
.days-text-field {
  display: inline-flex;
  width: 60px;
  padding: 0px !important;
  margin-top: 0px !important;
  margin-right: 8px !important;
  margin-left: 8px !important;
}

.dashboard-filter-options {
  .slipping-away-label {
    line-height: 64px;
  }

  .slipping-away-text-field {
    padding-top: 10px;
    width: 60px;
  }

  input {
    text-align: center;
  }
}
</style>